
import { MapTo } from '@adobe/aem-react-editable-components';
import CardFeatures, { CardFeaturesEditConfig } from './CardFeatures';

export default MapTo('cob-corp-acquisition/components/creditonebank/card-features')(CardFeatures, CardFeaturesEditConfig);
        